import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import {
  Chart,
  Interval,
  Tooltip,
  registerInteraction,
  Axis,
  Coord,
} from "bizcharts";
import { Box } from "@mui/system";
import DownloadButton from "../Common/DownloadButton";

const GradientColumnsChart = (props) => {
  const [data, setData] = useState([]);

  const csv = props.csv;
  const { readString } = usePapaParse();

  const handleReadString = () => {
    readString(csv, {
      complete: (results, file) => {
        setData(results.data);
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log("Error while parsing:", error, file);
      },
    });
  };

  useEffect(() => {
    handleReadString();
  }, []);

  registerInteraction("element-cursor-pointer", {
    start: [
      {
        trigger: "interval:mouseenter",
        action: (ctx) => {
          ctx.view.canvas.setCursor("pointer");
        },
      },
    ],
    end: [
      {
        trigger: "interval:mouseleave",
        action: (ctx) => {
          ctx.view.canvas.setCursor("default");
        },
      },
    ],
  });

  const [canvas, setCanvas] = useState(undefined);

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <p
          className="titleChart"
          style={{
            fontFamily: "Roboto Condensed, sans-serif",
            marginBottom: ".5rem",
          }}
        >
          {props.title}
        </p>
        <DownloadButton
          canvas={canvas}
          fileName={props.title}
          csv={data}
          isRaw
        />
      </Box>

      <Chart
        onGetG2Instance={(chartInstance) => {
          setTimeout(() => {
            setCanvas(chartInstance.canvas);
          }, 1000);
        }}
        height={400}
        autoFit
        data={data}
        interactions={[
          "active-region",
          "element-cursor-pointer",
          "element-active",
        ]}
        padding={[15, 20, 50, 20]}
      >
        <Coord transpose={window.innerWidth <= 900} />
        <Interval
          position="Animal product*Number of different pesticides found"
          state={{
            active: {
              style: {
                stroke: "white",
              },
            },
          }}
          color="#22294D"
        />
        <Axis name="Number of different pesticides found" />
        <Axis
          name="Animal product"
          label={{
            formatter(text, item, index) {
              let arr = text.split(" ");

              //if it has more than one word
              if (arr.length > 1) {
                return `${arr[0]}\n${arr[1]}`;
              } else {
                return `${arr[0]}`;
              }
            },
            style: {
              fontFamily: "Roboto Condensed, sans-serif",
              wordWrap: "break-word",
            },
          }}
        />
        <Tooltip
          shared
          itemTpl={
            '<li data-index={index} class="g2-tooltip-list-item" style="margin-bottom:3px;">' +
            '<span style="background-color:{color};width:10px;border-radius:50%;height:10px;display:inline-block;margin-right:8px;"></span>' +
            "{name}: {value}" +
            "</li>"
          }
          containerTpl={
            '<div class="g2-tooltip"  id="tooltipWrap" >' +
            '<div class="g2-tooltip-title" id="tooltipTitle" style="font-weight:bold;font-size:medium;color:#22294d;">  </div>' +
            '<ul class="g2-tooltip-list " style="color:#22294d;"></ul>' +
            "</div>"
          }
        />
      </Chart>
    </Box>
  );
};

export default GradientColumnsChart;
